// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueBus from 'vue-bus'
import Routers from './router'
import App from './App'

import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'

// import echarts from 'echarts';
import * as echarts from 'echarts'
import BaiduMap from 'vue-baidu-map'

// import preview
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import Video from 'video.js'
import 'video.js/dist/video-js.css'

import moment from "moment"
import md5 from 'js-md5'
import mammoth from "mammoth";

import api from './api/index'
import store from './store/index'

// import js
import common from './assets/js/common.js'

// import css
import './assets/css/animate.css'
import './assets/css/custom.css'
import './assets/css/style.css'
import './assets/css/media.css'

Vue.use(VueBus);
Vue.use(VueRouter);

Vue.use(ViewUI);

Vue.prototype.$echarts = echarts;
Vue.use(BaiduMap, {ak: 'C3Om4fqXeFmYHIA57PWQ96O2Vz0DpEAH'});

Vue.use(preview);

Vue.prototype.$video = Video;

Vue.prototype.$moment = moment;
Vue.prototype.$md5 = md5;
Vue.prototype.$mammoth = mammoth;

Vue.use(api);
Vue.prototype.$api = api;
Vue.prototype.$common = common;

// The routing configuration
// const RouterConfig = {
//   routes: Routers
// };

// 修复连续跳转两次路由的报错
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
};

const VueRouterReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function replace(location) {
    return VueRouterReplace.call(this, location).catch(err => err)
};


Vue.config.productionTip = false;

/* eslint-disable no-new */

window.VUE = new Vue({
    el: '#app',
    router: Routers,
    api,
    store,
    render: h => h(App),
});

/* LoadingBar */
Routers.beforeEach((to, from, next) => {
    // 路由改变修改页面Title
    if (to.meta.title) {
        // document.title = to.meta.title
        document.title = '源音文创-声闻'
    }
    ViewUI.LoadingBar.start();
    next();
});
Routers.afterEach(route => {
    ViewUI.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/main.js